import { findIndex } from 'lodash'
import Vue from 'vue'
import api from '../../../api_alv'
import i18n from '../../../assets/i18n/i18n'
import alvPlugin from '@/assets/helpers/alvPlugin'

const DIR = "label/statements"

const state = {
// List
    labelStatements: [],
    isAllSelectedLabelStatements: false,
    selectedLabelStatements: [],
    expandedLabelStatements: [],
    labelStatementsServerSideSortingOptions: {
        sortBy: ['createdOn'],
        sortDesc: [true],
        mustSort: true
    },

// Filters
    labelStatementsSearch: '',
    selectedLabelStatementsArchiveFilter: null,
    
// Actions 
    selectedLabelStatementsAction: [] ,

    // Run Statements
    selectedPeriodValues: {
        number: null,
        timeUnit: null,
        year: null
    }, 
    isLabelStatementsRunning: false,
    runningLabelStatementsPercentValues: [],

    //Statements preview
    labelStatementsStatementPreviewDialogDetailsStatementPreviewDate:alvPlugin.dateToISOFormat(new Date()),
    labelStatementsStatementPreviewDialogCreatePdfCheckbox: true,

    // Archiving
    showLabelStatemtensArchivingDialog: false,
    labelStatemtensArchivingDialogText: '',
    archivingInProgress:false,

    // Licensor payments dialog
    showLabelStatementsLicensorPaymentsDialog: false,
    selectedLabelStatementsLicensorPaymentsFromMonth: null,
    selectedLabelStatementsLicensorPaymentsToMonth: null,
    labelStatementsLicensorPaymentsAllowReport: true,
    labelStatementsLicensorPaymentsReportLink: null,

    // GLOC% statements dialog
    showGlocStatementsDialog: false,

// Details
    labelStatementsDetails: {},
    selectedLabelStatementsArchive: [],
    selectedLabelStatementsForDeleteArchive: ''
}

const getters = {
// List
    getLabelStatements(state) { return state.labelStatements },
    getIsAllSelectedLabelStatements(state) { return state.isAllSelectedLabelStatements },
    getSelectedLabelStatements(state) { return state.selectedLabelStatements },
    getExpandedLabelStatements(state) { return state.expandedLabelStatements },
    getLabelStatementsServerSideSortingOptions(state) { return state.labelStatementsServerSideSortingOptions },

// Filters
    getLabelStatementsSearch(state) { return state.labelStatementsSearch },
    getSelectedLabelStatementsArchiveFilter(state) { return state.selectedLabelStatementsArchiveFilter },

// Actions
    getSelectedLabelStatementsAction(state) { return state.selectedLabelStatementsAction },
    
    // Run Statements
    getSelectedPeriodValuesLabelStatements(state) { return state.selectedPeriodValues },
    getSelectedPeriodNumberLabelStatements (state) { return state.selectedPeriodValues.number },
    getSelectedPeriodTimeUnitLabelStatements(state) { return state.selectedPeriodValues.timeUnit },
    getSelectedPeriodYearLabelStatements(state) { return state.selectedPeriodValues.year },
    getIsLabelStatementsRunning(state) { return state.isLabelStatementsRunning },
    getRunningLabelStatementsPercentValues(state) { return state.runningLabelStatementsPercentValues },
    //Statements preview
    getLabelStatementsStatementPreviewDialogDetailsStatementPreviewDate(state) { return state.labelStatementsStatementPreviewDialogDetailsStatementPreviewDate },
    getLabelStatementsStatementPreviewDialogCreatePdfCheckbox(state) { return state.labelStatementsStatementPreviewDialogCreatePdfCheckbox },

    // Archiving
    getShowLabelStatemtensArchivingDialog(state) { return state.showLabelStatemtensArchivingDialog },
    getArchivingInProgress(state) { return state.archivingInProgress },

    // Licensor payments dialog
    getShowLabelStatementsLicensorPaymentsDialog(state) { return state.showLabelStatementsLicensorPaymentsDialog },
    getSelectedLabelStatementsLicensorPaymentsFromMonth(state) { return state.selectedLabelStatementsLicensorPaymentsFromMonth },
    getSelectedLabelStatementsLicensorPaymentsToMonth(state) { return state.selectedLabelStatementsLicensorPaymentsToMonth },
    getLabelStatementsLicensorPaymentsAllowReport(state) { return state.labelStatementsLicensorPaymentsAllowReport },
    getLabelStatementsLicensorPaymentsReportLink(state) { return state.labelStatementsLicensorPaymentsReportLink },

    // GLOC% statements dialog
    getShowGlocStatementsDialog(state) { return state.showGlocStatementsDialog },
    
// Details
    getLabelStatementsDetails(state) { return state.labelStatementsDetails },
    getSelectedLabelStatementsArchive(state) { return state.selectedLabelStatementsArchive },
    getSelectedLabelStatementsForDeleteArchive(state) { return state.selectedLabelStatementsForDeleteArchive },
}

const mutations = {
// List
    setLabelStatements: (state, labelStatements) => { state.labelStatements = labelStatements },
    setIsAllSelectedLabelStatements: (state, isSelected) => { state.isAllSelectedLabelStatements = isSelected },
    setSelectedLabelStatements: (state, selected) => { state.selectedLabelStatements = selected },
    setExpandedLabelStatements:(state, labelStatement) =>  { 
        if(Object.keys(labelStatement).length === 0) state.expandedLabelStatements = []
        else state.expandedLabelStatements.push(labelStatement) 
    },
    setLabelStatementsServerSideSortingOptions: (state, options) => { state.labelStatementsServerSideSortingOptions = options },
    

// Filters
    setLabelStatementsSearch: (state, value) => { state.labelStatementsSearch = value },
    setSelectedLabelStatementsArchiveFilter: (state, value) => { state.selectedLabelStatementsArchiveFilter = value },

// Actions
    setSelectedLabelStatementsAction: (state, selected) => { state.selectedLabelStatementsAction = selected },

    // Run Statements
    setSelectedPeriodValues: (state, selectedValues) => { state.selectedPeriodValues = selectedValues },
    setSelectedPeriodNumberLabelStatements: (state, newNumber) => { state.selectedPeriodValues.number = newNumber },
    setSelectedPeriodTimeUnitLabelStatements: (state, newValue) => { state.selectedPeriodValues.timeUnit = newValue },
    setSelectedPeriodYearLabelStatements: (state, newYear) => { state.selectedPeriodValues.year = newYear },
    setIsLabelStatementsRunning: (state, value) => { state.isLabelStatementsRunning = value },
    setRunningLabelStatementsPercentValues: (state, percentValues) => { state.runningLabelStatementsPercentValues = percentValues },
    //Statements preview
    setLabelStatementsStatementPreviewDialogDetailsStatementPreviewDate: (state, value) => { state.labelStatementsStatementPreviewDialogDetailsStatementPreviewDate = value },
    setLabelStatementsStatementPreviewDialogCreatePdfCheckbox: (state, value) => { state.labelStatementsStatementPreviewDialogCreatePdfCheckbox = value },

    // Archiving
    setShowLabelStatemtensArchivingDialog: (state, show) => { state.showLabelStatemtensArchivingDialog = show },
    setArchivingInProgress: (state, value) => { state.archivingInProgress = value },

    // Licensor payments dialog
    setShowLabelStatementsLicensorPaymentsDialog: (state, value) => {state.showLabelStatementsLicensorPaymentsDialog = value },
    setSelectedLabelStatementsLicensorPaymentsFromMonth:(state, value) => { state.selectedLabelStatementsLicensorPaymentsFromMonth = value },
    setSelectedLabelStatementsLicensorPaymentsToMonth:(state, value) => { state.selectedLabelStatementsLicensorPaymentsToMonth = value },
    setLabelStatementsLicensorPaymentsAllowReport: (state, value) => { state.labelStatementsLicensorPaymentsAllowReport = value },
    setLabelStatementsLicensorPaymentsReportLink: (state, value) => { state.labelStatementsLicensorPaymentsReportLink = value},

    // GLOC% statements dialog
    setShowGlocStatementsDialog: (state, value) => { state.showGlocStatementsDialog = value },

    // Details
    setLabelStatementsDetails: (state, details) => { state.labelStatementsDetails = details },
    setSelectedLabelStatementsArchive: (state, selected) => { state.selectedLabelStatementsArchive = selected },
    setSelectedLabelStatementsForDeleteArchive: (state, alvId) => { state.selectedLabelStatementsForDeleteArchive = alvId },
}

const actions = {
    // LIST
    async fetchLabelStatements({ commit, getters }) {
        commit('setIsLoading', true)
        
        // check for set filters
        const periodNumber = getters.getSelectedPeriodNumberLabelStatements
        const periodTimeUnit = getters.getSelectedPeriodTimeUnitLabelStatements
        const periodYear = getters.getSelectedPeriodYearLabelStatements
        let period = null
        if (periodTimeUnit === 'year' && periodYear) {
            period = 'year,' + periodYear
        } else if (periodNumber && periodTimeUnit && periodYear) {
            period = periodNumber + ',' + periodTimeUnit + ',' + periodYear
        }
        let filterObj = {
            'search' :  getters.getLabelStatementsSearch,
            'archiveFilter' : getters.getSelectedLabelStatementsArchiveFilter,
            'period' : period
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // Get list items from db
        // let response = await api.getListData(DIR, getters.getCurrentPage, paramsString) 
        let options = getters.getLabelStatementsServerSideSortingOptions  
        let response = await api.getListData2(DIR, getters.getCurrentPage, options.sortBy, options.sortDesc, paramsString)   
        
        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setLabelStatements', [])
        } else {
            commit('setLabelStatements', response.list)
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)
    },
    
    // DETAILS
    async fetchLabelStatementsDetails({ commit }, alvId) {
        let values

        let response = await api.getDetailsById(DIR, alvId)
        if(response === undefined || response.length === 0 || response.error === 1) {
            response = {}
            commit('setSnackbar', {
                type: 'error',
                msg: 'Daten konnten nicht oder nur unvollständig geladen werden'
            })
        } else values = response

        commit('setLabelStatementsDetails', values)
        commit('setIsLoading', false)
    },

    // DELETE
    async deleteSelectedLabelStatementsArchive({ getters, commit, dispatch}) {
        let response = await api.deleteEntries(DIR, [getters.getSelectedLabelStatementsArchive.alvId])

        if(response.error === -1) {
            await dispatch('fetchLabelStatementsDetails', getters.getSelectedLabelStatementsForDeleteArchive)
        }
        let index = getters.getExpandedLabelStatements.findIndex(statement => {
            return statement.alvId === getters.getSelectedLabelStatementsForDeleteArchive
        })
        getters.getExpandedLabelStatements.splice(index, 1)
        commit('setExpandedLabelStatements', getters.getLabelStatementsDetails)
        commit('setSelectedLabelStatementsArchive', [])
    },

    // ACTIONS Switch
    async doLabelStatementsAction({ commit, dispatch, getters }) {
        let selectedStatements = getters.getSelectedLabelStatements

        // check if any licensors are checked / selected by user
        if(selectedStatements.length === 0) {
            commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE')
            commit('setShowSelectionRequiredDialog', true)  
        } else {
            let selectedTimeUnit = getters.getSelectedPeriodTimeUnitLabelStatements
            let selectedPeriodNumber = getters.getSelectedPeriodNumberLabelStatements
            let selectedPeriodYear = getters.getSelectedPeriodYearLabelStatements

            // check period is selected correctly, either "year,2021" or "3,month,2021"
            if (selectedTimeUnit === 'year' && (selectedPeriodYear !== '' && selectedPeriodYear !== undefined && selectedPeriodYear !== null)) {
                var period = selectedTimeUnit + ',' + selectedPeriodYear }
            else if ((selectedTimeUnit === 'month' || selectedTimeUnit === 'quarter' || selectedTimeUnit === 'halfyear') && (
                        (selectedPeriodNumber !== '' && selectedPeriodNumber !== undefined && selectedPeriodNumber !== null) &&
                        (selectedPeriodYear !== '' && selectedPeriodYear !== undefined && selectedPeriodYear !== null) )) {
                var period = selectedPeriodNumber + ',' + selectedTimeUnit + ',' + selectedPeriodYear
            } else {
                var period = null
            }

            switch(getters.getSelectedLabelStatementsAction) {
                case 'launchStatementRun':
                    if (period !== null) {
                        commit('setIsLabelStatementsRunning', false)  
                        state.runningLabelStatementsPercentValues = []
                        commit('setShowStatementPreviewDialog', true)   
                    } else {
                        commit('setShowPeriodRequiredDialog', true)
                    }
                    break
                case 'archiveWithForwarded': case 'archiveWithoutForwarded':
                    commit('setShowLabelStatemtensArchivingDialog', true)
                    break
                case 'bulkDownload':
                    if (period !== null) {
                        let bulkDownloadResponse = await api.triggerAction(DIR, selectedStatements, {"action" : "bulkDownload", "period" : period})
                        api.getFileFromALV(bulkDownloadResponse.response.path)
                        commit('setSnackbar', {
                            type: 'success',
                            msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
                        })
                    } else {
                        commit('setShowPeriodRequiredDialog', true)
                    }
                    break
            }
        }
    },

    // ARCHIVE Statements
    async archiveLabelStatements({ getters, dispatch, commit }) {
        let selectedStatements = getters.getSelectedLabelStatements
        let metaData = { "alvIds": selectedStatements, "tags": {"add" : getters.getAddTag, "remove" : null} }
        let queryParams = { "action": getters.getSelectedLabelStatementsAction }
        commit('setArchivingInProgress',true)

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_LABEL_STATEMTENS_SNACKBAR_ARCHIVING_SUCCESSFULL')
            })

        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_LABEL_STATEMTENS_SNACKBAR_ARCHIVING_NOT_SUCCESSFULL')
            })
        }

        commit('setExpandedLabelStatements', [])
        commit('setSelectedLabelStatements', [])
        commit('setSelectedLabelStatementsAction',[])
        commit('setIsAllSelectedLabelStatements', false)
        commit('setArchivingInProgress',false)
        commit('setShowLabelStatemtensArchivingDialog', false)
        dispatch('fetchLabelStatements')
    },

    //Licensor Payments report
    async createLabelStatementsLicensorPaymentsReport({ getters, commit }){
        commit('setIsLoading', true)
        commit('setLabelStatementsLicensorPaymentsReportLink', null)
        let queryParams = { "action": 'licensorPaymentsReport' }
        let metaData = { 
            "from": getters.getSelectedLabelStatementsLicensorPaymentsFromMonth, 
            "to": getters.getSelectedLabelStatementsLicensorPaymentsToMonth
        }

        let response = await api.triggerAction(DIR, metaData, queryParams)
        
        if(response.error === -1) {
            commit('setLabelStatementsLicensorPaymentsReportLink', response.response.path)
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DOWNLOAD_NOT_SUCCESSFULL')
            })
        }

        commit('setIsLoading', false)

        
    },


    async createGlocStatements({ getters, commit }, period){
        let selectedPeriod = period.period
        commit('setIsLoading', true)
        
        let queryParams = { "action": 'glocStatements' }

        let metaData = { 
            "period": selectedPeriod
        }

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            if(response.response.path){
                api.getFileFromALV(response.response.path)
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
                })
            }
            if(response.response.message){
                    commit('setSnackbar', {
                    type: 'error',
                    msg: i18n.t(response.response.message)
                })
            }
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DOWNLOAD_NOT_SUCCESSFULL')
            })
        }

        commit('setIsLoading', false)
    }
}

export default {
    state, getters, actions, mutations
}